module.exports = __webpack_public_path__ + "static/img/server7.d4d1cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/server7.jpg
// module id = xg4d
// module chunks = 1